import { Component, OnInit, Inject, InjectionToken, Input } from '@angular/core';
import { BookingService } from '../services/booking.service';
import mixpanel from 'mixpanel-browser';

export interface BookingDetails {
  departure_on: string;
  arrival_on: string;
  trip_type: string;
  adult_count: number;
  child_count: number;
  infant_count: number;
  travel_class: string;
  from_data: {
    name: string;
    iata: string;
    city: string;
  };
  destination_data: {
    name: string;
    iata: string;
    city: string;
  };
}

export const BOOKING_DETAILS = 'BOOKING_DETAILS';

@Component({
    selector: 'app-nobuses',
    templateUrl: './nobuses.component.html',
    styleUrls: ['./nobuses.component.css'],
    standalone: false
})
export class NobusesComponent implements OnInit {
  @Input() bookingdetails: BookingDetails;

  constructor() {
    
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }



}
